import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.ZOOM_PHONE$AICONCIERGE],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_PHONE$AICONCIERGE),
      title: this.$t('billing.planform.title.zoom_phone_ai_concierge'),
      subtitle: '',
      planType: planTypes.ZOOM_PHONE$AICONCIERGE,
      bd_planType: planTypes.ZOOM_PHONE$AICONCIERGE,
      description: '',
    };
  },
};
